<template>
  <v-app id="login" class="secondary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="https://res.cloudinary.com/k-mioven/image/upload/v1625376563/dentoholic_logo.1629a27b_rp6ttn.svg"
                    alt="Vue Material Admin"
                    width="250"
                    class="mb-4"
                  />
                  <h1 class="flex my-4 primary--text">Dentoholic Admin</h1>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="userEmail"
                    :error="error"
                    :rules="[rules.required]"
                  />
                  <v-text-field
                    :type="hidePassword ? 'password' : 'text'"
                    :append-icon="
                      hidePassword ? 'visibility_off' : 'visibility'
                    "
                    name="password"
                    label="Password"
                    id="password"
                    :rules="[rules.required]"
                    v-model="password"
                    :error="error"
                    @click:append="hidePassword = !hidePassword"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="primary" @click="login" :loading="loading"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar v-model="showResult" :timeout="2000" top>
        {{ result }}
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      userEmail: "m.himi@mioven.com",
      password: "dento1258!",
      hidePassword: true,
      error: false,
      showResult: false,
      result: "",
      rules: {
        required: value => !!value || "Required."
      }
    };
  },

  methods: {
    async login() {
      const vm = this;
      this.$swal({
        title: "loggin in",
        text: "Please hold on for a moment",
        icon: "info",
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store
        .dispatch("auth/LOGIN", {
          email: this.userEmail,
          password: this.password
        })
        .then(response => {
          vm.$router.push({ name: "Dashboard" });
        });
      this.$swal.close();
    }
  }
};
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  background-color: #23a0a0;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
